import * as XLSX from "xlsx";
import ExcelJS from "exceljs";

// Layout de renglones de artículos (codigo, cantidad, precio) compartido por
// OrdenesCompraCreate y PedidosCreate. La columna codigo es una lista
// desplegable con los artículos activos del sistema ("CODIGO | NOMBRE").
export const SEP_LAYOUT = " | ";
const FILAS_LAYOUT = 500;

// instrucciones: arreglo de textos que van en la hoja "Instrucciones"
export async function descargarLayoutArticulos(articulos, nombreArchivo, instrucciones = []) {
  const catalogo = (articulos || [])
    .filter((a) => a.is_active !== "No")
    .sort((a, b) => (a.codigo > b.codigo ? 1 : -1));

  const wb = new ExcelJS.Workbook();
  const hoja = wb.addWorksheet("Layout"); // 1a hoja: es la que se lee al subir
  const hojaArt = wb.addWorksheet("Articulos");

  hoja.columns = [
    { header: "codigo", key: "codigo", width: 55 },
    { header: "cantidad", key: "cantidad", width: 12 },
    { header: "precio", key: "precio", width: 12 },
  ];
  hoja.getRow(1).font = { bold: true };
  hoja.views = [{ state: "frozen", ySplit: 1 }];

  hojaArt.columns = [
    { header: "opcion", key: "opcion", width: 55 },
    { header: "codigo", key: "codigo", width: 20 },
    { header: "nombre", key: "nombre", width: 45 },
  ];
  hojaArt.getRow(1).font = { bold: true };
  catalogo.forEach((a) =>
    hojaArt.addRow({ opcion: `${a.codigo}${SEP_LAYOUT}${a.nombre}`, codigo: a.codigo, nombre: a.nombre })
  );

  const rangoLista = `Articulos!$A$2:$A$${catalogo.length + 1}`;
  for (let r = 2; r <= FILAS_LAYOUT + 1; r++) {
    if (catalogo.length > 0) {
      hoja.getCell(`A${r}`).dataValidation = {
        type: "list", allowBlank: true, formulae: [rangoLista],
        showErrorMessage: true, errorTitle: "Artículo no válido", error: "Elige un artículo de la lista.",
      };
    }
    hoja.getCell(`B${r}`).dataValidation = {
      type: "decimal", operator: "greaterThan", allowBlank: true, formulae: [0],
      showErrorMessage: true, error: "La cantidad debe ser un número mayor a 0.",
    };
    hoja.getCell(`C${r}`).dataValidation = {
      type: "decimal", operator: "greaterThanOrEqual", allowBlank: true, formulae: [0],
      showErrorMessage: true, error: "El precio debe ser un número.",
    };
  }

  if (instrucciones.length) {
    const hojaInst = wb.addWorksheet("Instrucciones");
    hojaInst.addRow(["COMO LLENAR ESTE LAYOUT"]).font = { bold: true };
    hojaInst.addRow([]);
    instrucciones.forEach((t, i) => hojaInst.addRow([String(i + 1), t]));
    hojaInst.getColumn(1).width = 6;
    hojaInst.getColumn(2).width = 120;
  }

  const buffer = await wb.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = nombreArchivo;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// Lee la 1a hoja del layout. Regresa [{ renglon, codigo, cantidad, precio, precioCapturado }]
// sin renglones vacíos. Acepta "CODIGO | NOMBRE" (de la lista) o solo el código escrito.
export function leerLayoutArticulos(file) {
  return new Promise((resolve, reject) => {
    const lector = new FileReader();
    lector.onerror = reject;
    lector.onload = (e) => {
      try {
        const wb = XLSX.read(new Uint8Array(e.target.result), { type: "array" });
        const crudas = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { defval: "" });
        const dame = (f, col) => {
          const k = Object.keys(f).find((x) => String(x).trim().toLowerCase() === col);
          return k ? f[k] : "";
        };
        const filas = crudas
          .map((f, i) => {
            const precioTxt = String(dame(f, "precio") ?? "").trim();
            return {
              renglon: i + 2,
              codigo: String(dame(f, "codigo") ?? "").split(SEP_LAYOUT)[0].trim(),
              cantidad: parseFloat(String(dame(f, "cantidad")).replace(/[$,\s]/g, "")) || 0,
              precio: parseFloat(precioTxt.replace(/[$,\s]/g, "")) || 0,
              precioCapturado: precioTxt !== "",
            };
          })
          .filter((f) => f.codigo);
        resolve(filas);
      } catch (err) {
        reject(err);
      }
    };
    lector.readAsArrayBuffer(file);
  });
}
